const genObject = (object) => JSON.parse(JSON.stringify(object));
export default genObject;
